import React, { useEffect, useState, useRef } from 'react';

const TrainingRoom = () => {
    const [completed, setCompleted] = useState(() => {
        const savedCompleted = localStorage.getItem('completedVideos');
        return savedCompleted ? JSON.parse(savedCompleted) : Array(11).fill(false);
    });
    const [players, setPlayers] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [progress, setProgress] = useState(0);
    const [apiReady, setApiReady] = useState(false);
    const playersRef = useRef([]);

    const videos = [
        { videoId: 'ZQvfHyfgBtA', checkboxId: 'checkbox-0', title: 'Introduction to Sales', creator: 'Sales Expert', length: '10:30' },
        { videoId: 'UC-GJbheknHZhSM7-Jgn63jg', checkboxId: 'checkbox-1', title: 'Building Rapport', creator: 'Communication Coach', length: '15:45' },
        { videoId: 'sqABsYvofLo', checkboxId: 'checkbox-2', title: 'Needs Assessment', creator: 'Sales Strategist', length: '12:20' },
        { videoId: 'wEGjZoTBitg', checkboxId: 'checkbox-3', title: 'Product Knowledge', creator: 'Product Specialist', length: '18:15' },
        { videoId: 'gch2xKboZrg', checkboxId: 'checkbox-4', title: 'Overcoming Objections', creator: 'Negotiation Expert', length: '14:50' },
        { videoId: 'GTVMt62S9wU', checkboxId: 'checkbox-5', title: 'Closing Techniques', creator: 'Sales Closer', length: '16:40' },
        { videoId: 'hzjIigX8nHQ', checkboxId: 'checkbox-6', title: 'Follow-up Strategies', creator: 'Customer Relations', length: '11:55' },
        { videoId: 'nerdwallet-video', checkboxId: 'checkbox-7', title: 'Sales Ethics', creator: 'Business Ethics Professor', length: '13:30' },
        { videoId: '-R8QoUdkJNU', checkboxId: 'checkbox-8', title: 'Time Management', creator: 'Productivity Coach', length: '17:20' },
        { videoId: 'aBFE1xtf8x0', checkboxId: 'checkbox-9', title: 'Sales Technology', creator: 'Tech Specialist', length: '19:10' },
        { videoId: 'kqMUTHN5kqg', checkboxId: 'checkbox-10', title: 'Advanced Selling', creator: 'Sales Guru', length: '20:25' },
    ];

    useEffect(() => {
        // Load YouTube API
        if (!window.YT) {
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubeIframeAPIReady = () => setApiReady(true);
        } else {
            setApiReady(true);
        }

        // Initialize progress
        updateProgress(completed);

        // Cleanup function
        return () => {
            playersRef.current.forEach(player => {
                if (player && player.destroy) {
                    player.destroy();
                }
            });
        };
    }, []);

    useEffect(() => {
        if (apiReady) {
            initializePlayers();
        }
    }, [apiReady]);

    useEffect(() => {
        // Save completed status to localStorage whenever it changes
        localStorage.setItem('completedVideos', JSON.stringify(completed));
        updateProgress(completed);
    }, [completed]);

    const initializePlayers = () => {
        const newPlayers = videos.map((video, index) => {
            if (playersRef.current[index]) {
                playersRef.current[index].destroy();
            }
            return new window.YT.Player(`player-${index}`, {
                height: '150',
                width: '250',
                videoId: video.videoId,
                events: {
                    'onReady': (event) => {
                        // Store the player instance in the ref
                        playersRef.current[index] = event.target;
                    },
                    'onStateChange': (event) => onPlayerStateChange(event, index),
                },
            });
        });
        setPlayers(newPlayers);
    };

    const onPlayerStateChange = (event, index) => {
        if (event.data === window.YT.PlayerState.ENDED) {
            setCompleted(prev => {
                const updatedCompleted = [...prev];
                updatedCompleted[index] = true;
                return updatedCompleted;
            });
        }
    };

    const updateProgress = (completedArray) => {
        const completedCount = completedArray.filter(Boolean).length;
        const newProgress = Math.round((completedCount / videos.length) * 100);
        setProgress(newProgress);
        setIsButtonDisabled(completedCount !== videos.length);
    };

    return (
        <div className='training-room-container'>
            <main>
                <section className="course-section">
                    <h2>Amie Sales Training</h2>
                    <div className="progress-bar">
                        <div className="progress" style={{width: `${progress}%`}}></div>
                        <span className="progress-text">{progress}% Complete</span>
                    </div>
                    <div className="content-wrapper">
                        <div className="modules">
                            <div className="module-container">
                                <h3>All Modules</h3>
                                <div className='videos-container'>
                                {videos.map((video, index) => (
                                    <div className="module" key={index}>
                                        <h4>Module {Math.floor(index / 2) + 1}: Lesson {index + 1}</h4>
                                        <div className="lesson">
                                            <div className="lesson-info">
                                                <h5>{video.title}</h5>
                                                <p><strong>Creator:</strong> {video.creator}</p>
                                                <p><strong>Length:</strong> {video.length}</p>
                                                <label className="checkbox-container">
                                                    <input
                                                        type="checkbox"
                                                        id={video.checkboxId}
                                                        checked={completed[index]}
                                                        readOnly
                                                    />
                                                    <span className="checkmark"></span>
                                                    Completed
                                                </label>
                                            </div>
                                            <div className="video-wrapper">
                                                <div id={`player-${index}`}></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <button id="enter-amie-btn" disabled={isButtonDisabled} onClick={handleEnterAmie}>
                        Enter Amie
                    </button> */}
                </section>
            </main>
        </div>
    );
};

export default TrainingRoom;